import { render, staticRenderFns } from "./PendingSeverities.vue?vue&type=template&id=7632817d&"
import script from "./PendingSeverities.vue?vue&type=script&lang=ts&"
export * from "./PendingSeverities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports